import { ENDPOINTS } from "@/constants/endpoints"
import { HTTP_METHODS } from "@/constants/httpMethods"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenereicMutation } from "@/hooks/useGenericMutation"
import type {
  FreeMaterial,
  FreeMaterialCourse,
  FreeMaterialReviewDTO,
} from "@/types/freeMaterialsTypes"

export function useEnrollIntoFreeMaterialCourseMutation() {
  return useGenereicMutation<FreeMaterialCourse>({
    createEndpoint: (course) => ENDPOINTS.freeMaterials.enroll(course.id),
    method: HTTP_METHODS.POST,
    invalidationKeys: [
      QUERY_KEYS.freeMaterials.index(),
      QUERY_KEYS.freeMaterials.enrollments(),
    ],
  })
}

export function useMarkFreeMaterialAsDoneMutation() {
  return useGenereicMutation<{ free_material_id: number }>({
    createEndpoint: () => ENDPOINTS.freeMaterials.markAsDone(),
    method: HTTP_METHODS.POST,
    invalidationKeys: [
      QUERY_KEYS.freeMaterials.index(),
      QUERY_KEYS.freeMaterials.enrollments(),
    ],
  })
}

export function useRemoveFreeMaterialAsDoneMutation() {
  return useGenereicMutation<FreeMaterial>({
    createEndpoint: (material) =>
      ENDPOINTS.freeMaterials.removeDone(material?.progress?.id || 0),
    method: HTTP_METHODS.DELETE,
    invalidationKeys: [
      QUERY_KEYS.freeMaterials.index(),
      QUERY_KEYS.freeMaterials.enrollments(),
    ],
  })
}

// reviews

export function useAddFreeMaterialReviewMutation(courseId?: number) {
  return useGenereicMutation<FreeMaterialReviewDTO>({
    createEndpoint: () => ENDPOINTS.freeMaterials.addReview(courseId || 0),
    method: HTTP_METHODS.POST,
    invalidationKeys: [
      QUERY_KEYS.freeMaterials.index(),
      QUERY_KEYS.freeMaterials.reviews(courseId),
    ],
  })
}

export function useEditFreeMaterialReviewMutation(courseId?: number) {
  return useGenereicMutation<FreeMaterialReviewDTO>({
    createEndpoint: (data) => ENDPOINTS.freeMaterials.editReview(data?.id || 0),
    method: HTTP_METHODS.PUT,
    invalidationKeys: [
      QUERY_KEYS.freeMaterials.index(),
      QUERY_KEYS.freeMaterials.reviews(courseId),
    ],
  })
}

export function useRemoveFreeMaterialReviewMutation(courseId?: number) {
  return useGenereicMutation<FreeMaterialReviewDTO>({
    createEndpoint: (data) =>
      ENDPOINTS.freeMaterials.deleteReview(data?.id || 0),
    method: HTTP_METHODS.DELETE,
    invalidationKeys: [
      QUERY_KEYS.freeMaterials.index(),
      QUERY_KEYS.freeMaterials.reviews(courseId),
    ],
  })
}
